import { init } from '@/features/clickstream-sdk/initialize';
export default defineNuxtPlugin(init);
